import PropTypes from 'prop-types';
import React, { Component } from 'react';

class CountryDetails extends Component {
  static propTypes = {
    country: PropTypes.string,
  };

  getCountryName() {
    const words = this.props.country.split(' ');
    return words
      .map((word) => {
        if (!word) {
          return '';
        }
        let lowerCase = word.toLowerCase();
        return lowerCase.replace(/(^| )(\w)/g, (firstLetter) =>
          firstLetter.toUpperCase()
        );
      })
      .join(' ');
  }

  render() {
    return (
      <p className="system-details">
        {this.getCountryName()}
      </p>
    );
  }
}

export default CountryDetails;
